<template>
  <div class="LayoutLogged" id="LayoutLogged">
    <LeftBar
      id="left-side-bar"
      @open="updateMenuStatus(true)"
      @close="updateMenuStatus(false)"
      :show="showMenu"
    />
    <div class="content-container">
      <Header />
      <main class="LayoutLogged__main">
        <div class="main__content">
          <transition name="fade" mode="out-in">
            <slot />
          </transition>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import Header from "@/components/layoutLogged/Header.vue";
import LeftBar from "@/components/layoutLogged/LeftBar.vue";

export default {
  name: "LayoutLogged",
  props: {
    name: {
      type: String,
      required: false
    }
  },
  computed: {
    showMenu() {
      return this.$store.getters["general/getStatusMenu"];
    }
  },
  components: {
    Header,
    LeftBar
  },
  mounted() {
    this.$store.dispatch("general/updateSystems");
  },
  methods: {
    toggleMenu(status) {
      this.showMenu = status;
    },
    updateMenuStatus(newStatus) {
      this.$store.dispatch("general/updateShowMenu", newStatus);
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/style/css/generic-variables.scss";

.LayoutLogged {
  height: 100%;
  display: flex;
  flex-direction: row;
  .content-container {
    flex-grow: 1;
  }
  .LayoutLogged__main {
    height: 100%;
    .main__content {
      width: 100%;
      height: 100%;
      .content {
        height: 100%;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transition: opacity 0s;
  opacity: 0;
}
</style>
